/**
 * Sanitized IAP diagnostics — no receipts, tokens, JWT, email, or transaction payloads.
 */

export function sanitizeIapError(err: unknown): { code: string; message: string } {
  if (err && typeof err === 'object') {
    const e = err as { code?: string; message?: string };
    return {
      code: String(e.code ?? 'UNKNOWN'),
      message: String(e.message ?? 'Unknown error').slice(0, 200),
    };
  }
  return { code: 'UNKNOWN', message: String(err ?? 'Unknown error').slice(0, 200) };
}

export function logIap(event: string, fields?: Record<string, string | number | boolean>): void {
  if (!fields || Object.keys(fields).length === 0) {
    console.log(event);
    return;
  }
  const parts = Object.entries(fields).map(([k, v]) => `${k}=${v}`);
  console.log(`${event} ${parts.join(' ')}`);
}

export function delayMs(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
